const COLOURS = {
  PURPLE_100: '#F5F2FF',
  PURPLE_200: '#CAB6FF',
  PURPLE_300: '#A579FF',
  PURPLE_400: '#844AFF',
  PURPLE_500: '#5622D8',
  PURPLE_600: '#500FD9',
  PURPLE_700: '#3A00B3',
  PURPLE_800: '#27008C',
  PURPLE_900: '#180066',

  BLUE_100: '#E3F7FF',
  BLUE_200: '#AADFFF',
  BLUE_300: '#72D3FF',
  BLUE_400: '#3AB9FF',
  BLUE_500: '#0397FF',
  BLUE_600: '#007FFF',
  BLUE_700: '#0066CC',
  BLUE_800: '#004C99',
  BLUE_900: '#003366',

  GREY_BLUE: '#B0B8C5',

  GREEN_900: '#006662',
  GREEN_800: '#007e52ff',
  GREEN_700: '#00B397',
  GREEN_600: '#00D9AB',
  GREEN_500: '#00FFBA',
  GREEN_400: '#39FFD5',
  GREEN_300: '#72FFE9',
  GREEN_200: '#AAFFF7',
  GREEN_100: '#E3FFFE',

  RED: '#ff6663',
  RED_DARKER: '#d40400',
  RED_DARKEST: '#800200',

  PRIMARY: '#5622D8',
  SECONDARY: '#0397FF',

  BLACK: '#1E1E1E',
  WARM_NEUTRAL: '#CCCBC6',
  COOL_NEUTRAL: '#FAF9F2',

  GREY_50: '#F0F2F4',
  GREY_100: '#D6DAE1',
  GREY_300: '#A1AABA',
  GREY_500: '#6C7A93',
  GREY_700: '#464f5e',
  GREY_800: '#323843',
  GREY_900: '#1E2229',

  GREEN_ALT: '#006662',
  GREEN_ALT_200: '#B0C14B',

  ORANGE: '#E48233',

  YELLOW: '#FFBB00',
}

const GRADIENTS = {
  STANDARD: `linear-gradient(175deg, ${COLOURS.PRIMARY} 59%, ${COLOURS.SECONDARY} 60%)`,
  FADED: `linear-gradient(175deg, ${COLOURS.PRIMARY}50 59%, ${COLOURS.SECONDARY}50 60%)`,
  BAR: `linear-gradient(161deg, ${COLOURS.PRIMARY} 11%, ${COLOURS.SECONDARY} 83%)`,
  TRANSPARENT:
    'linear-gradient(161deg, rgba(105, 44, 255, 0.75) 11%, rgba(0, 255, 186, 0.75) 83%)',
}

export const COLOUR = {
  // STATE COLOURS
  SUCCESS: COLOURS.GREEN_700,
  SUCCESS_DARK: COLOURS.GREEN_800,
  SUCCESS_DARKER: COLOURS.GREEN_900,
  WARNING: COLOURS.YELLOW,
  ALERT: COLOURS.RED,
  ALERT_DARK: COLOURS.RED_DARKER,
  ALERT_DARKER: COLOURS.RED_DARKEST,
  HIGHLIGHT: 'rgb(207, 102, 157)',
  ERROR: COLOURS.RED_DARKER,
  ORANGE: COLOURS.ORANGE,
  TEXT_HIGHLIGHT: COLOURS.GREY_BLUE,

  // ACTIONS
  PRIMARY_LIGHTEST: COLOURS.PURPLE_100,
  PRIMARY_LIGHTER: COLOURS.PURPLE_200,
  PRIMARY_LIGHT: COLOURS.PURPLE_300,
  PRIMARY: COLOURS.PURPLE_500,
  PRIMARY_DARK: COLOURS.PURPLE_700,
  PRIMARY_DARKER: COLOURS.PURPLE_800,
  PRIMARY_DARKEST: COLOURS.PURPLE_900,
  PRIMARY_FADED: `${COLOURS.PURPLE_500}50`,

  SECONDARY_LIGHTEST: COLOURS.BLUE_100,
  SECONDARY_LIGHTER: COLOURS.BLUE_200,
  SECONDARY_LIGHT: COLOURS.BLUE_300,
  SECONDARY: COLOURS.BLUE_500,
  SECONDARY_DARK: COLOURS.BLUE_700,
  SECONDARY_DARKER: COLOURS.BLUE_800,
  SECONDARY_DARKEST: COLOURS.BLUE_900,
  SECONDARY_FADED: `${COLOURS.BLUE_500}50`,
  SECONDARY_ALT: COLOURS.BLUE_900,

  // DESIGN ELEMENTS
  BACKGROUND_PRIMARY: 'white',
  BACKGROUND_HIGHLIGHT: 'rgba(255,255,255,0.2)',
  BACKGROUND_TRANSPARENT: 'rgba(255,255,255,0.5)',

  BACKGROUND_SHADOW: COLOURS.GREY_50,
  BACKGROUND_LIGHTEST: COLOURS.GREY_100,
  BACKGROUND_LIGHT: COLOURS.GREY_300,
  BACKGROUND_MEDIUM: COLOURS.GREY_500,
  BACKGROUND_DARK: COLOURS.GREY_700,
  BACKGROUND_DARKER: COLOURS.GREY_800,
  BACKGROUND_DARKEST: COLOURS.GREY_900,

  MODAL_BACKGROUND: COLOURS.GREY_500,

  TEXT: '#464646',
  ICON: COLOURS.GREY_500,
  BACKGROUND_DARK_OPACITY: 'rgba(76,94,108,0.7)',
  LIGHT_TEXT: '#EAECEF',

  TEXT_STANDARD: COLOURS.GREY_900,

  GRADIENT_STANDARD: GRADIENTS.STANDARD,
  GRADIENT_FADED: GRADIENTS.FADED,
  GRADIENT_BAR: GRADIENTS.BAR,
  GRADIENT_TRANSPARENT: GRADIENTS.TRANSPARENT,
  WHITE: '#FFFFFF',
}

export const DARK_COLOUR = {
  // STATE COLOURS
  SUCCESS: COLOURS.GREEN_700,
  SUCCESS_DARK: COLOURS.GREEN_800,
  SUCCESS_DARKER: COLOURS.GREEN_900,
  WARNING: COLOURS.YELLOW,
  ALERT: COLOURS.RED,
  ALERT_DARK: '#FFCA28',
  ALERT_DARKER: COLOURS.RED_DARKEST,
  HIGHLIGHT: 'rgb(207, 102, 157)',
  ERROR: COLOURS.RED_DARKER,
  ORANGE: COLOURS.ORANGE,
  TEXT_HIGHLIGHT: COLOURS.GREY_BLUE,

  // ACTIONS
  PRIMARY_LIGHTEST: '#EBD9FF',
  PRIMARY_LIGHTER: '#D1AFFF',
  PRIMARY_LIGHT: '#B584FF',
  PRIMARY: '#8F55FF',
  PRIMARY_DARK: '#6E3FCC',
  PRIMARY_DARKER: '#502F99',
  PRIMARY_DARKEST: '#321F66',
  PRIMARY_FADED: '#8F55FF50',

  SECONDARY_LIGHTEST: '#D4F3F3',
  SECONDARY_LIGHTER: '#A9E6E6',
  SECONDARY_LIGHT: '#7ACACA',
  SECONDARY: '#4BA7A7',
  SECONDARY_DARK: '#357979',
  SECONDARY_DARKER: '#234F4F',
  SECONDARY_DARKEST: '#152D2D',
  SECONDARY_FADED: '#4BA7A750',
  SECONDARY_ALT: '#152D2D',

  // DESIGN ELEMENTS
  BACKGROUND_PRIMARY: 'white',
  BACKGROUND_HIGHLIGHT: 'rgba(255,255,255,0.2)',
  BACKGROUND_TRANSPARENT: 'rgba(255,255,255,0.5)',

  BACKGROUND_SHADOW: '#1E2127',
  BACKGROUND_LIGHTEST: '#4A515E',
  BACKGROUND_LIGHT: '#404651',
  BACKGROUND_MEDIUM: '#434A59',
  BACKGROUND_DARK: '#2A2F38',
  BACKGROUND_DARKER: '#23272E',
  BACKGROUND_DARKEST: '#1A1D23',

  MODAL_BACKGROUND: COLOURS.GREY_500,

  TEXT: '#EAECEF',
  BACKGROUND_DARK_OPACITY: 'rgba(76,94,108,0.7)',
  LIGHT_TEXT: '#EAECEF',
  ICON: '#EAECEF',
  TEXT_STANDARD: '#EAECEF',

  GRADIENT_STANDARD: GRADIENTS.STANDARD,
  GRADIENT_FADED: GRADIENTS.FADED,
  GRADIENT_BAR: GRADIENTS.BAR,
  GRADIENT_TRANSPARENT: GRADIENTS.TRANSPARENT,
  WHITE: '#FFFFFF',
}

export const LIGHT_COLOUR = {
  // STATE COLOURS
  SUCCESS: COLOURS.GREEN_700,
  SUCCESS_DARK: COLOURS.GREEN_800,
  SUCCESS_DARKER: COLOURS.GREEN_900,
  WARNING: COLOURS.YELLOW,
  ALERT: COLOURS.RED,
  ALERT_DARK: COLOURS.RED_DARKER,
  ALERT_DARKER: COLOURS.RED_DARKEST,
  HIGHLIGHT: 'rgb(207, 102, 157)',
  ERROR: COLOURS.RED_DARKER,
  ORANGE: COLOURS.ORANGE,
  TEXT_HIGHLIGHT: COLOURS.GREY_BLUE,

  // ACTIONS
  PRIMARY_LIGHTEST: '#E7E9FF',
  PRIMARY_LIGHTER: '#C2C8FF',
  PRIMARY_LIGHT: '#9FA8FF',
  PRIMARY: '#5A67FF',
  PRIMARY_DARK: '#2E3AD1',
  PRIMARY_DARKER: '#1F289B',
  PRIMARY_DARKEST: '#151C6F',
  PRIMARY_FADED: '#5A67FF50',

  SECONDARY_LIGHTEST: '#E6F7F6',
  SECONDARY_LIGHTER: '#BFEFEA',
  SECONDARY_LIGHT: '#8FD7D1',
  SECONDARY: '#4FB0A8',
  SECONDARY_DARK: '#397C78',
  SECONDARY_DARKER: '#265454',
  SECONDARY_DARKEST: '#153636',
  SECONDARY_FADED: '#4FB0A850',
  SECONDARY_ALT: '#153636',
  // DESIGN ELEMENTS
  BACKGROUND_PRIMARY: 'white',
  BACKGROUND_HIGHLIGHT: 'rgba(255,255,255,0.2)',
  BACKGROUND_TRANSPARENT: 'rgba(255,255,255,0.5)',

  BACKGROUND_SHADOW: '#D1D4DA',
  BACKGROUND_LIGHTEST: '#FFFFFF',
  BACKGROUND_LIGHT: '#F1F3F7',
  BACKGROUND_MEDIUM: '#C8CDD5',
  BACKGROUND_DARK: '#A1A7B3',
  BACKGROUND_DARKER: '#767E8D',
  BACKGROUND_DARKEST: '#4E5562',

  MODAL_BACKGROUND: '#FFFFFF',

  TEXT: '#464646',
  BACKGROUND_DARK_OPACITY: 'rgba(76,94,108,0.7)',
  LIGHT_TEXT: '#EAECEF',
  ICON: COLOURS.GREY_500,
  TEXT_STANDARD: COLOURS.GREY_900,

  GRADIENT_STANDARD: GRADIENTS.STANDARD,
  GRADIENT_FADED: GRADIENTS.FADED,
  GRADIENT_BAR: GRADIENTS.BAR,
  GRADIENT_TRANSPARENT: GRADIENTS.TRANSPARENT,
  WHITE: '#FFFFFF',
}
